export enum ELanguage {
  ENGLISH = 'en',
  CZECH = 'cs',
  SLOVAK = 'sk',
}
